<template>
  <div>
    <div class="d-flex align-items-center justify-content-between mb-1" style="min-height: 31px">
      <p class="fs-11 font-weight-bold text-uppercase mb-0" style="color: #8a939d; letter-spacing: 0.04em">Submitals asociados</p>
      <b-button
        v-if="permissions.can_manage_items"
        variant="outline-secondary"
        size="sm"
        class="d-flex align-items-center"
        style="color: #163D7D; border-color: #c7d0dc; border-radius: 8px"
        @click="modalShow = true"
      >
        <font-awesome-icon :icon="['far', 'edit']" class="mr-1" />
        Gestionar
      </b-button>
    </div>

    <p v-if="items.length === 0" class="text-center text-muted my-3">No hay submitals relacionados</p>

    <ul v-else class="list-unstyled mb-0" style="max-height: 220px; overflow-y: auto">
      <li
        v-for="(item, index) in items"
        :key="item.id"
        class="d-flex align-items-center py-2"
        :class="{ 'border-bottom': index < items.length - 1 }"
      >
        <b-link
          v-if="item.url"
          v-bind="linkProps(item.url)"
          class="fs-14 font-weight-bold flex-shrink-0 mr-2"
          style="min-width: 56px"
        >
          {{ item.code }}
        </b-link>
        <span v-else class="fs-14 font-weight-bold flex-shrink-0 mr-2" style="min-width: 56px; color: #163D7D">
          {{ item.code }}
        </span>

        <span class="fs-14 text-muted text-truncate flex-grow-1" style="min-width: 0; contain: inline-size" :title="item.title">
          {{ item.title }}
        </span>

        <span class="fs-14 font-weight-bold flex-shrink-0 ml-2" :style="{ color: progressColor(item.progress) }">
          {{ progressText(item.progress) }}
        </span>
      </li>
    </ul>

    <DrawingRequestItemsModal
      v-if="modalShow && permissions.can_manage_items"
      :drawing-request="drawingRequest"
      :cached-items="availableItems"
      @loaded="availableItems = $event"
      @close="modalShow = false"
      @item-added="$emit('item-added', $event)"
      @item-removed="$emit('item-removed', $event)"
    />
  </div>
</template>

<script>
import DrawingRequestItemsModal from './DrawingRequestItemsModal'

export default {
  name: 'DrawingRequestShowItems',
  components: { DrawingRequestItemsModal },
  props: {
    drawingRequest: { type: Object, required: true },
    permissions: { type: Object, default: () => ({}) }
  },
  data () {
    return {
      modalShow: false,
      availableItems: null
    }
  },
  computed: {
    items () {
      return this.drawingRequest.drawing_request_items || []
    }
  },
  methods: {
    linkProps (url) {
      return url.startsWith('/app/') ? { to: url } : { href: url }
    },
    progressText (progress) {
      if (progress === null || progress === undefined) return '—'
      return `${Math.round(progress)}%`
    },
    progressColor (progress) {
      return Math.round(progress) >= 100 ? '#1e7e34' : '#163D7D'
    }
  }
}
</script>
